import { useNavigate } from "react-router-dom";
import { ReactComponent as PasswordIlustration } from "../assets/images/password-ilustration.svg";
import Button from "../components/button/Button";
import Paragraph from "../components/paragraph/Paragraph";
import Steps from "../components/steps/Steps";
import useAuthPersistStore from "../store/authPersistStore";
import { useRequestPasswordChange } from "../hooks/useRequestPasswordChange";
import { ROUTES } from "../constants/routes";

const ChangePasswordRequest = () => {
  const navigate = useNavigate();
  const { user } = useAuthPersistStore();
  const { mutate, isLoading } = useRequestPasswordChange();

  return (
    <div className="create-profile-success">
      <Steps activeStep={1} steps={4} />
      <div className="create-profile-success_page">
        <PasswordIlustration className="hover-float" />
        <div className="create-profile-success_content">
          <div className="create-profile-success_header">
            <h1>Želite da promenite lozinku?</h1>
            <Paragraph variant="p2">{user?.email}</Paragraph>
          </div>
          <div className="create-profile_cta">
            <Button
              maxContent={true}
              onClick={() => navigate(ROUTES.profile)}
              label="Nazad"
              variant="secondary"
            />
            <Button
              variant="primary"
              label="Dalje"
              type="submit"
              hasLoader={true}
              isLoading={isLoading}
              disabled={isLoading}
              onClick={() =>
                mutate(
                  {},
                  {
                    onSuccess: () => {
                      navigate(ROUTES.changePasswordRequestSuccess);
                    },
                  }
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordRequest;
